import { formatSpecialization } from '@lighthouse/shared';

interface TherapistSpecializationPillsProps {
  specializations: string[];
  limit?: number;
  size?: 'sm' | 'md';
  variant?: 'default' | 'hero' | 'muted';
  label?: string;
}

const PILL_STYLES = {
  default: 'spec-pill',
  md: 'spec-pill-md',
  hero: 'spec-pill-hero',
  muted: 'spec-pill-muted',
};

export function TherapistSpecializationPills({
  specializations,
  limit,
  size = 'sm',
  variant = 'default',
  label,
}: TherapistSpecializationPillsProps) {
  const visible = limit ? specializations.slice(0, limit) : specializations;
  const remaining = limit ? Math.max(0, specializations.length - limit) : 0;

  const pillClass =
    variant === 'hero'
      ? PILL_STYLES.hero
      : variant === 'muted'
        ? PILL_STYLES.muted
        : size === 'md'
          ? PILL_STYLES.md
          : PILL_STYLES.default;

  if (visible.length === 0) return null;

  return (
    <div className="space-y-1">
      {label && (
        <p
          className={
            variant === 'hero'
              ? 'text-primary-100/90 text-[10px] font-semibold uppercase tracking-wide'
              : 'text-[10px] font-semibold uppercase tracking-wide text-gray-500'
          }
        >
          {label}
        </p>
      )}
      <div className="flex flex-wrap items-center gap-1">
        {visible.map((spec) => (
          <span key={spec} className={pillClass}>
            {formatSpecialization(spec)}
          </span>
        ))}
        {remaining > 0 && (
          <span
            className={
              variant === 'hero'
                ? 'text-primary-100/80 text-[10px] font-medium'
                : 'text-[10px] font-medium text-gray-500'
            }
          >
            +{remaining}
          </span>
        )}
      </div>
    </div>
  );
}
